import {css, cx} from "@panda/css";

import {DashboardIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {kmAppLink} from "@pg-mono/km-routes";
import {KM_COMMON_TEST_IDS} from "@pg-mono/test-ids";

import {Divider} from "@/components/Divider";
import {useHomeMatchPreferencesSurvey} from "@/features/home_match/providers/HomeMatchPreferencesSurveyProvider";
import {kmFeatureFlagHomeMatch} from "@/features/km_app/utils/read_environment_variables";
import {NavigationAmplitudeTracker} from "@/features/tracking/amplitude/navigation_amplitude_tracker";

import {NAVIGATION_LABELS} from "../constants/navigation_labels";
import {navigationItemActiveStyle, navigationItemHoverStyle, navigationLinkStyle} from "../constants/navigation_shared_styles";
import {useProfileMenuItems} from "../hooks/use_profile_menu_items";
import {useNavigationSections} from "../hooks/useNavigationSections";
import {UserProfileMenuVariant} from "../types/UserProfileMenuVariant";
import {GoToPortalButton} from "./GoToPortalButton";
import {NavigationLinkItem, navigationLinkItemResetStyle} from "./NavigationLinkItem";
import {NavLogo} from "./NavLogo";
import {OffersNavGroup} from "./OffersNavGroup";
import {PreferencesNavCta} from "./PreferencesNavCta";
import {UserProfileMenu} from "./UserProfileMenu";

export const DesktopSidebar = () => {
    const {DASHBOARD} = NAVIGATION_LABELS;
    const {site} = useNavigationSections();
    const {preferencesItem} = useProfileMenuItems();
    const preferencesSurvey = useHomeMatchPreferencesSurvey();
    const dashboardPath = kmAppLink.site.dashboard({site});

    return (
        <aside className={sidebarStyle}>
            <div className={logoRowStyle}>
                <NavLogo />
                <GoToPortalButton />
            </div>

            <div className={sidebarBodyStyle}>
                <div className={sidebarNavStyle}>
                    <Text className={navSectionLabelStyle} color="var(--colors-gray-700)" variant="info_txt_3">
                        {NAVIGATION_LABELS.NAV_SECTION.DESKTOP}
                    </Text>

                    <NavigationLinkItem
                        activeClassName={navigationItemActiveStyle}
                        className={cx(navigationLinkStyle, navigationItemHoverStyle, navigationLinkItemResetStyle)}
                        dataTestId={KM_COMMON_TEST_IDS.NAV_DASHBOARD}
                        onNavigate={() => NavigationAmplitudeTracker.selectMenuSection({selectedTab: DASHBOARD.NAV_ITEM})}
                        to={dashboardPath}
                    >
                        <DashboardIcon width="24" height="24" />
                        <Text variant="info_txt_1">{DASHBOARD.NAV_ITEM}</Text>
                    </NavigationLinkItem>

                    <OffersNavGroup />
                </div>

                <div className={sidebarFooterStyle}>
                    {kmFeatureFlagHomeMatch && preferencesItem && (
                        <>
                            <Divider className={footerDividerStyle} />
                            <PreferencesNavCta
                                dataTestId={KM_COMMON_TEST_IDS.NAV_PREFERENCES}
                                label={preferencesItem.label}
                                onNavigate={() => {
                                    NavigationAmplitudeTracker.selectSettingsSection({selectedTab: preferencesItem.label});
                                    preferencesSurvey.open();
                                }}
                            />
                        </>
                    )}

                    <UserProfileMenu showPreferencesCta={false} variant={UserProfileMenuVariant.DESKTOP} />
                </div>
            </div>
        </aside>
    );
};

const logoRowStyle = css({
    alignItems: "center",
    display: "flex",
    gap: 1,
    justifyContent: "space-between"
});

const sidebarStyle = css({
    position: "fixed",
    top: 1,
    left: 1,
    bottom: 1,
    display: "flex",
    flexDirection: "column",
    width: "28rem",
    backgroundColor: "var(--colors-white)",
    boxShadow: "var(--shadow-3)",
    borderRadius: 2,
    p: 1,
    zIndex: "var(--zIndex-navigationChrome)"
});

const sidebarBodyStyle = css({
    display: "flex",
    flex: 1,
    flexDirection: "column",
    justifyContent: "space-between",
    mt: 5,
    minHeight: 0
});

const sidebarNavStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1
});

const navSectionLabelStyle = css({
    pl: 2,
    letterSpacing: "0.19em"
});

const sidebarFooterStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 2
});

const footerDividerStyle = css({
    ml: -1,
    mb: 1,
    width: "calc(100% + 1.6rem)"
});
import {css, cx} from "@panda/css";

import {DashboardIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {kmAppLink} from "@pg-mono/km-routes";
import {KM_COMMON_TEST_IDS} from "@pg-mono/test-ids";

import {Divider} from "@/components/Divider";
import {useHomeMatchPreferencesSurvey} from "@/features/home_match/providers/HomeMatchPreferencesSurveyProvider";
import {kmFeatureFlagHomeMatch} from "@/features/km_app/utils/read_environment_variables";
import {NavigationAmplitudeTracker} from "@/features/tracking/amplitude/navigation_amplitude_tracker";

import {NAVIGATION_LABELS} from "../constants/navigation_labels";
import {navigationItemActiveStyle, navigationItemHoverStyle, navigationLinkStyle} from "../constants/navigation_shared_styles";
import {useProfileMenuItems} from "../hooks/use_profile_menu_items";
import {useNavigationSections} from "../hooks/useNavigationSections";
import {UserProfileMenuVariant} from "../types/UserProfileMenuVariant";
import {GoToPortalButton} from "./GoToPortalButton";
import {NavigationLinkItem, navigationLinkItemResetStyle} from "./NavigationLinkItem";
import {NavLogo} from "./NavLogo";
import {OffersNavGroup} from "./OffersNavGroup";
import {PreferencesNavCta} from "./PreferencesNavCta";
import {UserProfileMenu} from "./UserProfileMenu";

export const DesktopSidebar = () => {
    const {DASHBOARD} = NAVIGATION_LABELS;
    const {site} = useNavigationSections();
    const {preferencesItem} = useProfileMenuItems();
    const preferencesSurvey = useHomeMatchPreferencesSurvey();
    const dashboardPath = kmAppLink.site.dashboard({site});

    return (
        <aside className={sidebarStyle}>
            <div className={logoRowStyle}>
                <NavLogo />
                <GoToPortalButton />
            </div>

            <div className={sidebarBodyStyle}>
                <div className={sidebarNavStyle}>
                    <Text className={navSectionLabelStyle} color="var(--colors-gray-700)" variant="info_txt_3">
                        {NAVIGATION_LABELS.NAV_SECTION.DESKTOP}
                    </Text>

                    <NavigationLinkItem
                        activeClassName={navigationItemActiveStyle}
                        className={cx(navigationLinkStyle, navigationItemHoverStyle, navigationLinkItemResetStyle)}
                        dataTestId={KM_COMMON_TEST_IDS.NAV_DASHBOARD}
                        onNavigate={() => NavigationAmplitudeTracker.selectMenuSection({selectedTab: DASHBOARD.NAV_ITEM})}
                        to={dashboardPath}
                    >
                        <DashboardIcon width="24" height="24" />
                        <Text variant="info_txt_1">{DASHBOARD.NAV_ITEM}</Text>
                    </NavigationLinkItem>

                    <OffersNavGroup />
                </div>

                <div className={sidebarFooterStyle}>
                    {kmFeatureFlagHomeMatch && preferencesItem && (
                        <>
                            <Divider className={footerDividerStyle} />
                            <PreferencesNavCta
                                dataTestId={KM_COMMON_TEST_IDS.NAV_PREFERENCES}
                                label={preferencesItem.label}
                                onNavigate={() => {
                                    NavigationAmplitudeTracker.selectSettingsSection({selectedTab: preferencesItem.label});
                                    preferencesSurvey.open();
                                }}
                            />
                        </>
                    )}

                    <UserProfileMenu showPreferencesCta={false} variant={UserProfileMenuVariant.DESKTOP} />
                </div>
            </div>
        </aside>
    );
};

const logoRowStyle = css({
    alignItems: "center",
    display: "flex",
    gap: 1,
    justifyContent: "space-between"
});

const sidebarStyle = css({
    position: "fixed",
    top: 1,
    left: 1,
    bottom: 1,
    display: "flex",
    flexDirection: "column",
    width: "28rem",
    backgroundColor: "var(--colors-white)",
    boxShadow: "var(--shadow-3)",
    borderRadius: 2,
    p: 1,
    zIndex: "var(--zIndex-navigationChrome)"
});

const sidebarBodyStyle = css({
    display: "flex",
    flex: 1,
    flexDirection: "column",
    justifyContent: "space-between",
    mt: 5,
    minHeight: 0
});

const sidebarNavStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1
});

const navSectionLabelStyle = css({
    pl: 2,
    letterSpacing: "0.19em"
});

const sidebarFooterStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 2
});

const footerDividerStyle = css({
    ml: -1,
    mb: 1,
    width: "calc(100% + 1.6rem)"
});
